'use strict';
var processInclude = require('./util');

$(document).ready(function () {
    processInclude(require('./thirdParty/jPages'));
    processInclude(require('./components/favoriteStore'));
    processInclude(require('./storeLocator/storeLocator'));
});
